export default __webpack_public_path__ + "static/media/fireplace.816138e4.webp";